import React from 'react';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import WrapperSection from '../../components/global/WrapperSection';
import FormAddEditLevel from '../../components/levels/FormAddEditLevel';
import { useParams } from 'react-router-dom';
import { useGetLevel } from '../../hooks/levels/useGetLevel';
import LoadingPage from '../../components/global/LoadingPage';

const EditLevel = () => {
    const { id } = useParams();
    const { level, isLoading } = useGetLevel(id);

    if (isLoading) return <LoadingPage />;

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditLevel isEdit currentData={level?.data} />
        </WrapperSection>
    );
};

export default EditLevel;
